const MUTATION_NAME = {
  SET_USERNAME: "setUsername",
  SET_USER_LOCALE: "setUserLocale",
  SET_USER_TIMEZONE: "setUserTimezone",
  SET_DOMAIN: "setDomain",
  SET_CRM_SERVER_URL: "setCRMServerURL",
  SET_CRM_SERVER_VERSION: "setCRMServerVersion",
  SET_MC_SERVER_URL: "setMCServerURL",
  SET_MC_SERVER_VERSION: "setMCServerVersion",
  SET_TERRITORY_SERVER_URL: "setTerritoryServerURL",
  SET_TERRITORY_SERVER_VERSION: "setTerritoryVersion",
  SET_USER: "setUser",
  SET_ORG: "setOrg",
  SET_MESSAGES: "setMessages",
  SET_APPS: "setApps",
  ADD_APP: "addApp",
  UPDATE_APP: "updateApp",
  UPDATE_IS_DIRTY_FLAG: "updateIsDirtyFlag",
  SET_APPTYPES: "setAppTypes",
  SET_OBJECT_NAME_LABELS: "setObjectNameLabels",
  SET_APPS_DEPLOYMENT_SUMMARY: "setAppsDeploymentSummary",
  SET_HTML_REPORT_FIELD_LABELS: "setHtmlReportFieldLabels",
  EDIT_DATA_PALETTES: "editDataPalettes",
  DELETE_DATA_ELEMENT: "deleteDataElement",
  UPDATE_DATA_ELEMENT_NAME: "updateDataElementName",
  UPDATE_DE_QUERY: "updateDEQuery",
  SET_OBJECT_DESCRIBE: "setObjectDescribe",
  SET_DELETE_DRAGGABLE: "setDeleteDraggable",
  SET_EDIT_DRAGGABLE: "setEditDraggable",
  SET_UPDATE_DRAGGABLE: "setUpdateDraggable",
  SET_MOVE_DRAGGABLE: "setMoveDraggable",
  SET_LATEST_APPS: "setLaterstApps",
  SET_CURRENT_CONTENT: "setCurrentContent",
  SET_SF_GLOBAL_OBJECTS: "setSfGlobalObjects",
  SET_SF_OBJECTS_INFO: "setSfObjectsInfo",
  SET_SF_ENTRY_POINT_OBJECTS_INFO: "sfEntryPointObjectsInfo",
  SET_SF_OBJECTS_META: "setSfObjectsMeta",
  SET_NITRO_DATA_CACHE: "setNitroDataCache",
  SET_EDIT_DATA_ELEMENT: "setEditDataElement",
  SET_PAGE_INFO: "setPageInfo",
  SET_HAS_SESSION: "setHasSession",
  DISTRIBUTION_CHANNELS_SUMMARY: "distributionChannelsSummary",
  UPDATE_DISTRIBUTION_CHANNEL_SUMMARY_NAME: "updateDistributionChannelName",
  DISTRIBUTION_CHANNEL_DETAIL: "distributionChannelDetail",
  UPDATE_DISTRIBUTION_CHANNEL_DETAIL: "updateDistributionChannelDetail",
  DISTRIBUTION_CHANNEL_LATEST_WIDGETS: "distributionChannelLatestWidgets",
  DELETE_LATEST_UNPUBLISHED_WIDGET: "deletLatestUnpublishedWidget",
  WIDGET_VERSIONS: "widgetVersions",
  CHANNEL_WIDGET_VERSION_LIST: "channelWidgetVersionList",
  CUSTOMER_DOMAIN_WIDGET_ACCESS: "customerDomainWidgetAccess",
  SETUP_CUSTOMER_DOMAIN_WIDGET_ACCESS: "setupCustomerDomainWidgetAccess",
  DELETE_UNPUBLISHED_WIDGET_VERSION: "deleteUnpublishedWidgetVersion",
  WIDGET_TRANSLATIONS: "widgetTranslations",
  ALL_WIDGET_TRANSLATIONS: "allWidgetTranslations",
  WIDGET_TRANSLATION_REQUEST: "widgetTranslationRequest",
  UPDATE_WIDGET_TRANSLATION: "updateWidgetTranslation",
  ADD_WIDGET_TRANSLATION: "addWidgetTranslation",
  DELETE_WIDGET_TRANSLATION: "deleteWidgetTranslation",
  ADD_WIDGET_DATA: "addWidgetData",
  ADD_NEW_WIDGET: "addNewWidget",
  ADD_NEW_WIDGET_VERSION: "addNewWidgetVersion",
  UPDATE_LATEST_UNPUBLISHED_VERSION: "updateLatestUnpublshedVersion",
  UPDATE_WIDGET_UNPUBLISHED_VERSION: "updateWidgetUnpublshedVersion",
  WIDGET_VERSION_DETAILS: "widgetVersionDetails",
  ALL_WIDGET_VERSION_DETAILS: "allWidgetVersionDetails",
  SET_PUBLISHED_VERSION_LATEST_WIDGET: "updateVersionLatestWidget",
  SET_PUBLISHED_VERSION_WIDGET_VERSIONS: "updateUnpublishedWidgetVersion",
  CUSTOMER_DOMAINS: "customerDomains",
  CUSTOMER_DOMAIN_DATA: "customerDomainData",
  ADD_CUSTOMER_DOMAIN: "addCustomerDomain",
  UPDATE_CUSTOMER_DOMAIN_LEVEL_ACCESS: "updateCustomerDomainLevelAccess",
  DELETE_CUSTOMER_DOMAIN: "deleteCustomerDomain",
  DISTRIBUTION_CHANNEL_LIST: "distributionChannelList",
  RESET_CHANNEL_PAGE_DATA: "resetChannelPageData",
  ADD_EDIT_WIDGET_DATA: "addEditWidgetData",
  REFRESH_OVERVIEW: "refreshOverview",
  SET_IS_FETCHING_MANIFESTS: "setIsFetchingManifests",
  EDIT_DROPDOWN_REFERENCE: "editDropdownReference",
  SET_OLS: "setOLS",
  SET_PREVIEW_PLATFORM: "setPreviewPlatform"
};

const DEPLOYMENTS_COLUMN_KEYS = [
  "Name",
  "RecordTypeId",
  "Profile_Name_vod__c",
  "Object_RecordType_vod__c",
  "Platform_vod__c",
  "Phone_vod__c",
  "External_Id_vod__c",
  "Visibility_Criteria_vod__c",
  "Sharing_Group_vod__c",
  "Studio_Version_vod__c",
  "Status_vod__c",
  "Failure_Msg_vod__c"
];

const OBJECT_NAME_LABELS = [
  "Account",
  "Account_Plan_vod__c",
  "Order_vod__c",
  "Inventory_Monitoring_vod__c",
  "EM_Speaker_vod__c",
  "Call2_vod__c"
];

const CREATE_WIZARD_SEARCH_MAP = {
  Territory_Insights_vod: {
    contentType: "Territory"
  },
  Territory_Insights_Default_vod: {
    contentType: "Territory"
  },
  Territory_Feedback_vod: {
    contentType: "Territory Feedback"
  },
  Account_Reports_vod: {
    contentType: "Account",
    object: "Account",
    fields: ["Id", "Name", "Formatted_Name_vod__c"],
    where:
      "((Name LIKE '%userInput%') OR (Formatted_Name_vod__c LIKE '%userInput%'))"
  },
  Account_Profile_Override_vod: {
    contentType: "Account",
    object: "Account",
    fields: ["Id", "Name", "Formatted_Name_vod__c"],
    where:
      "((Name LIKE '%userInput%') OR (Formatted_Name_vod__c LIKE '%userInput%'))"
  },
  KOL_Profile_vod: {
    contentType: "Account",
    object: "Account",
    fields: ["Id", "Name", "Formatted_Name_vod__c"],
    where:
      "((Name LIKE '%userInput%') OR (Formatted_Name_vod__c LIKE '%userInput%'))"
  },
  Account_Plan_vod: {
    contentType: "Account Plan",
    object: "Account_Plan_vod__c",
    fields: ["Id", "Name", "Account_vod__r.Formatted_Name_vod__c"],
    where:
      "((Name LIKE '%userInput%') OR (Account_vod__r.Name LIKE '%userInput%') OR (Account_vod__r.Formatted_Name_vod__c LIKE '%userInput%'))"
  },
  Inventory_Monitoring_vod: {
    contentType: "Inventory Monitoring",
    object: "Inventory_Monitoring_vod__c",
    fields: ["Id", "Name", "Account_vod__r.Formatted_Name_vod__c"],
    where:
      "((Name LIKE '%userInput%') OR (Account_vod__r.Name LIKE '%userInput%') OR (Account_vod__r.Formatted_Name_vod__c LIKE '%userInput%'))"
  },
  Orders_vod: {
    contentType: "Orders",
    object: "Order_vod__c",
    fields: ["Id", "Name", "Account_vod__r.Formatted_Name_vod__c"],
    where:
      "((Name LIKE '%userInput%') OR (Account_vod__r.Name LIKE '%userInput%') OR (Account_vod__r.Formatted_Name_vod__c LIKE '%userInput%'))"
  },
  Full_Speaker_Profile_vod: {
    contentType: "Speaker",
    object: "EM_Speaker_vod__c",
    fields: ["Id", "Name", "Account_vod__r.Formatted_Name_vod__c"],
    where:
      "((Name LIKE '%userInput%') OR (Account_vod__r.Name LIKE '%userInput%') OR (Account_vod__r.Formatted_Name_vod__c LIKE '%userInput%'))"
  },
  Full_Speaker_Profile_Default_vod: {
    contentType: "Speaker",
    object: "EM_Speaker_vod__c",
    fields: ["Id", "Name", "Account_vod__r.Formatted_Name_vod__c"],
    where:
      "((Name LIKE '%userInput%') OR (Account_vod__r.Name LIKE '%userInput%') OR (Account_vod__r.Formatted_Name_vod__c LIKE '%userInput%'))"
  },
  Call2_vod: {
    contentType: "Call",
    object: "Call2_vod__c",
    fields: ["Id, Name, Account_vod__r.Formatted_Name_vod__c"],
    where: "(Name LIKE '%userInput%')"
  }
};

const VEEVA_MESSAGE_NAME_QUERY_TEMPLATE = {
  object: "Message_vod__c",
  fields: ["Id", "Category_vod__c", "Description_vod__c", "Name"],
  limit: 10,
  where:
    "Active_vod__c = true AND Language_vod__c = 'userLanguage' AND ((Category_vod__c LIKE '%categoryInput%') AND (Name LIKE '%msgNameInput%'))"
};

const VEEVA_MESSAGE_CATEGORY_QUERY_TEMPLATE = {
  object: "Message_vod__c",
  fields: ["COUNT(Id)", "Category_vod__c"],
  limit: 25,
  where:
    "Language_vod__c = 'en_US' AND Category_vod__c LIKE '%categoryInput%' GROUP BY Category_vod__c"
};

// STUDIO_MESSAGES size should be kept
// to about 100 entries. If necessary split the array in two.
const STUDIO_MESSAGES = [
  {
    name: "NEW_CONTENT",
    category: "MI_STUDIO"
  },
  {
    name: "BROWSER_TITLE",
    category: "MI_STUDIO"
  },
  {
    name: "SHOW_DEPLOYMENTS",
    category: "MI_STUDIO"
  },
  {
    name: "HIDE_DEPLOYMENTS",
    category: "MI_STUDIO"
  },
  {
    name: "ARCHIVE",
    category: "MI_STUDIO"
  },
  {
    name: "CONTENT_NAME",
    category: "MI_STUDIO"
  },
  {
    name: "CONTENT_TYPE",
    category: "MI_STUDIO"
  },
  {
    name: "TEST_RECORD",
    category: "MI_STUDIO"
  },
  {
    name: "DATA_PALETTE",
    category: "MI_STUDIO"
  },
  {
    name: "HOME",
    category: "MI_STUDIO"
  },
  {
    name: "SETTINGS",
    category: "MI_STUDIO"
  },
  {
    name: "DATA_ELEMENT",
    category: "MI_STUDIO"
  },
  {
    name: "DATA_ELEMENT_TYPE",
    category: "MI_STUDIO"
  },
  {
    name: "INVALID_NAME",
    category: "MI_STUDIO"
  },
  {
    name: "CONFIGURATION",
    category: "MI_STUDIO"
  },
  {
    name: "OBJECT",
    category: "MI_STUDIO"
  },
  {
    name: "PREVIEW",
    category: "MI_STUDIO"
  },
  {
    name: "RENAME",
    category: "MI_STUDIO"
  },
  {
    name: "DEPLOY_VERSION",
    category: "MI_STUDIO"
  },
  {
    name: "ALL_CHANGES_SAVED",
    category: "MI_STUDIO"
  },
  {
    name: "UNSAVED_CHANGED",
    category: "MI_STUDIO"
  },
  {
    name: "DEPLOYMENT_ABOUT_TO",
    category: "MI_STUDIO"
  },
  {
    name: "UPDATE_X_RECORDS",
    category: "MI_STUDIO"
  },
  {
    name: "REMOVE_X_RECORDS",
    category: "MI_STUDIO"
  },
  {
    name: "CREATE_X_RECORDS",
    category: "MI_STUDIO"
  },
  {
    name: "API_NAME",
    category: "MI_STUDIO"
  },
  {
    name: "RESTORE_UNSAVED_PROMPT",
    category: "MI_STUDIO"
  },
  {
    name: "SAVE_SUCCESS",
    category: "MI_STUDIO"
  },
  {
    name: "SAVE_ERROR",
    category: "MI_STUDIO"
  },
  {
    name: "RESTORE",
    category: "MI_STUDIO"
  },
  {
    name: "FAILED_TO_LOAD_CONTENT_LIST",
    category: "MI_STUDIO"
  },
  {
    name: "SFDC_METADATA_ERROR",
    category: "MI_STUDIO"
  },
  {
    name: "SFDC_DATA_ERROR",
    category: "MI_STUDIO"
  },
  {
    name: "FAILED_TO_LOAD_DEPLOYMENTS",
    category: "MI_STUDIO"
  },
  {
    name: "ERROR_WHILE_LOADING",
    category: "MI_STUDIO"
  },
  {
    name: "SFDC_LOGGED_OUT",
    category: "MI_STUDIO"
  },
  {
    name: "DATA_NOT_FOUND",
    category: "MI_STUDIO"
  },
  {
    name: "TIMEOUT_DURING_QUERY",
    category: "MI_STUDIO"
  },
  {
    name: "VALIDATION_ERROR_GENERIC",
    category: "MI_STUDIO"
  },
  {
    name: "DISP_EL_SECTION",
    category: "MI_STUDIO"
  },
  {
    name: "INCLUDE_HEADER",
    category: "MI_STUDIO"
  },
  {
    name: "ICON_INPUT",
    category: "MI_STUDIO"
  },
  {
    name: "TITLE_INPUT",
    category: "MI_STUDIO"
  },
  {
    name: "FIELD_LIST_STYLE_LABEL",
    category: "MI_STUDIO"
  },
  {
    name: "DISP_EL_FIELD_LIST",
    category: "MI_STUDIO"
  },
  {
    name: "FIELD_LIST_ITEM_LABEL",
    category: "MI_STUDIO"
  },
  {
    name: "FIELD_LIST_ITEM_VALUE",
    category: "MI_STUDIO"
  },
  {
    name: "FIELD_LIST_STYLE_ABOVE",
    category: "MI_STUDIO"
  },
  {
    name: "FIELD_LIST_STYLE_INLINE",
    category: "MI_STUDIO"
  },
  {
    name: "FIELD_LIST_STYLE_HORIZONTAL",
    category: "MI_STUDIO"
  },
  {
    name: "DISP_EL_TABLE",
    category: "MI_STUDIO"
  },
  {
    name: "COLUMN",
    category: "MI_STUDIO"
  },
  {
    name: "FILTER_BY",
    category: "MI_STUDIO"
  },
  {
    name: "DATA_SOURCE",
    category: "MI_STUDIO"
  },
  {
    name: "DISP_EL_TREND",
    category: "MI_STUDIO"
  },
  {
    name: "TREND_DATE_LABEL",
    category: "MI_STUDIO"
  },
  {
    name: "TREND_DATE_FORMAT_LABEL",
    category: "MI_STUDIO"
  },
  {
    name: "TREND_VALUE_LABEL",
    category: "MI_STUDIO"
  },
  {
    name: "TREND_SERIES_LABEL",
    category: "MI_STUDIO"
  },
  {
    name: "TREND_DATE_UNIT_LABEL",
    category: "MI_STUDIO"
  },
  {
    name: "TABLE_COLUMNS",
    category: "MI_STUDIO"
  },
  {
    name: "TABLE_COL_HEADER",
    category: "MI_STUDIO"
  },
  {
    name: "TABLE_COL_VALUE",
    category: "MI_STUDIO"
  },
  {
    name: "FORMAT",
    category: "MI_STUDIO"
  },
  {
    name: "DATE_UNIT_DAYS",
    category: "MI_STUDIO"
  },
  {
    name: "DATE_UNIT_WEEKS",
    category: "MI_STUDIO"
  },
  {
    name: "DATE_UNIT_MONTHS",
    category: "MI_STUDIO"
  },
  {
    name: "DATE_UNIT_YEARS",
    category: "MI_STUDIO"
  },
  {
    name: "MISSING_VIEW_SETUP",
    category: "MI_STUDIO"
  },
  {
    name: "SKIP",
    category: "MI_STUDIO"
  },
  {
    name: "KEEP",
    category: "MI_STUDIO"
  },
  {
    name: "DISP_EL_PROGRESS",
    category: "MI_STUDIO"
  },
  {
    name: "PROGRESS_VALUE_LABEL",
    category: "MI_STUDIO"
  },
  {
    name: "PROGRESS_GOAL_LABEL",
    category: "MI_STUDIO"
  },
  {
    name: "PROGRESS_OVERFLOW",
    category: "MI_STUDIO"
  },
  {
    name: "DEPLOYABLE",
    category: "MI_STUDIO"
  },
  {
    name: "VIEW_USER_ACTIONS",
    category: "MI_STUDIO"
  },
  {
    name: "NAVIGATION_ACTION",
    category: "MI_STUDIO"
  },
  {
    name: "EDIT_RECORD",
    category: "MI_STUDIO"
  },
  {
    name: "VIEW_RECORD",
    category: "MI_STUDIO"
  },
  {
    name: "RECORD_ID",
    category: "MI_STUDIO"
  },
  {
    name: "USER_ACTION_COUNT",
    category: "MI_STUDIO"
  },
  {
    name: "DESCRIPTION",
    category: "MI_STUDIO"
  },
  {
    name: "RECORD_TYPES_MISSING",
    category: "MI_STUDIO"
  }
];

// EXP_MESSAGES size should be kept
// to about 100 entries. If necessary split the array in two.
const EXP_MESSAGES = [
  {
    name: "EXP_LIST_OF_EXPRESSIONS",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LABEL_DATE",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LABEL_DATE_UNIT",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_RELATED_FIELD",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_RELATED_FIELD_GET",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_RELATED_FIELD_WHERE",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_RELATED_FIELD_MATCHES",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_RELATED_FIELD_FILTER",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_ROUND_NUM",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_SUM",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_PRODUCT",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_IF",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LABEL_IF",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LABEL_THEN",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LABEL_ELSE",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_FIELD_IN_LIST",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LABEL_RECORDS",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LABEL_FIELD",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LIST_OF_EXPRESSIONS",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_ANY",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_ALL",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_NOT_IN",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LABEL_NOT_IN",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_IN",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LABEL_IN",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_EQUAL",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LABEL_BOOL",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_NOT_EQUAL",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_NOT",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LABEL_GEN_LIST",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_MAX",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_MIN",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_DATE_DAY_IN_MONTH",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_DATE_YEAR",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_DATE_MONTH",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_ADD_NUM",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_MULTIPLY_NUM",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_SUBTRACT_NUM",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_DIVIDE_NUM",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_CONCAT",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LABEL_JOIN_STRING",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LABEL_STRING_LIST",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_FORMAT_DATE",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_GTE",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_GT",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LTE",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LT",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_COUNT_UNIQUE",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LABEL_FORMAT",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_NUMBER_TO_STRING",
    category: "MI_STUDIO"
  },
  {
    name: "EXP_LABEL_DECIMALS",
    category: "MI_STUDIO"
  }
];

// VEEVA_MESSAGE size should be kept
// to about 100 entries. If necessary split the array in two.
const VEEVA_MESSAGES = [
  {
    name: "NEXT",
    category: "View"
  },
  {
    name: "SIGN_OUT",
    category: "Common"
  },
  {
    name: "Edit",
    category: "Common"
  },
  {
    name: "PREVIEW",
    category: "Common"
  },
  {
    name: "OK",
    category: "Common"
  },
  {
    name: "CANCEL",
    category: "Common"
  },
  {
    name: "Account",
    category: "Common"
  },
  {
    name: "KOL_PROFILE",
    category: "Medical"
  },
  {
    name: "SEARCH",
    category: "Common"
  },
  {
    name: "KOL_PROFILE",
    category: "Medical"
  },
  {
    name: "CONFIRM_DELETE",
    category: "Common"
  },
  {
    name: "NAME",
    category: "Common"
  },
  {
    name: "ADD_ITEM",
    category: "Common"
  },
  {
    name: "FIELD",
    category: "View"
  },
  {
    name: "DELETE_OBJECT",
    category: "Common"
  },
  {
    name: "ASCENDING",
    category: "Common"
  },
  {
    name: "DESCENDING",
    category: "Common"
  },
  {
    name: "SORT_BY",
    category: "Common"
  },
  {
    name: "OPR_AND",
    category: "View"
  },
  {
    name: "ACTION",
    category: "Common"
  },
  {
    name: "UPDATE",
    category: "Common"
  },
  {
    name: "REMOVE",
    category: "Common"
  },
  {
    name: "Create",
    category: "Common"
  },
  {
    name: "NEW",
    category: "Common"
  },
  {
    name: "DEPLOY",
    category: "Common"
  },
  {
    name: "ARE_YOU_SURE",
    category: "Common"
  },
  {
    name: "STATUS",
    category: "Common"
  },
  {
    name: "Success",
    category: "Common"
  },
  {
    name: "SAVE",
    category: "Common"
  },
  {
    name: "SANDBOX",
    category: "TABLET"
  },
  {
    name: "Production",
    category: "TABLET"
  },
  {
    name: "TYPE",
    category: "Common"
  },
  {
    name: "LABEL",
    category: "Common"
  },
  {
    name: "RETRY",
    category: "Common"
  },
  {
    name: "PAGE",
    category: "Common"
  },
  {
    name: "BOOLEAN_FALSE",
    category: "View"
  },
  {
    name: "BOOLEAN_TRUE",
    category: "View"
  },
  {
    name: "APPROVED_NOTES_CATEGORY",
    category: "ApprovedNotes"
  },
  {
    name: "START_DATE",
    category: "SalesData"
  },
  {
    name: "END_DATE",
    category: "SalesData"
  },
  {
    name: "DATA_TYPE",
    category: "SalesData"
  },
  {
    name: "SCALE",
    category: "SalesData"
  },
  {
    name: "Weekly",
    category: "SalesData"
  },
  {
    name: "Monthly",
    category: "SalesData"
  },
  {
    name: "ID",
    category: "TABLET"
  },
  {
    name: "MARKET",
    category: "SalesData"
  },
  {
    name: "SALES_DATE",
    category: "SalesData"
  },
  {
    name: "SALES_DATA",
    category: "SalesData"
  },
  {
    name: "OPTIONS",
    category: "Common"
  }
];

const ACCOUNT_ENTRY_POINT_OBJECTS = ["Account", "User"];

const TERRITORY_ENTRY_POINT_OBJECTS = ["User"];

const TERRITORY_FEEDBACK_ENTRY_POINT_OBJECTS = ["User"];

const ACCOUNT_PLAN_ENTRY_POINT_OBJECTS = [
  "Account",
  "Account_Plan_vod__c",
  "User"
];

const ORDER_ENTRY_POINT_OBJECTS = ["Account", "User", "Order_vod__c"];

const INVENTORY_MONITORING_POINT_OBJECTS = [
  "Account",
  "User",
  "Inventory_Monitoring_vod__c"
];

const SPEAKER_ENTRY_POINT_OBJECTS = ["User", "EM_Speaker_vod__c"];

const CALL_ENTRY_POINT_OBJECTS = ["Call2_vod__c", "User", "Account"];

const VISIBILITY_CRITERIA_TYPES = ["Account", "Speaker"];

const ENTRY_POINT_OBJECTS_MAPPING = {
  Territory: TERRITORY_ENTRY_POINT_OBJECTS,
  Account: ACCOUNT_ENTRY_POINT_OBJECTS,
  Orders: ORDER_ENTRY_POINT_OBJECTS,
  Account_Plan: ACCOUNT_PLAN_ENTRY_POINT_OBJECTS,
  Inventory_Monitoring: INVENTORY_MONITORING_POINT_OBJECTS,
  Speaker: SPEAKER_ENTRY_POINT_OBJECTS,
  Territory_Feedback: TERRITORY_FEEDBACK_ENTRY_POINT_OBJECTS,
  Call: CALL_ENTRY_POINT_OBJECTS
};

const REQUIRED_FLS_TO_DEPLOY = {
  HTML_Report_vod__c: ["Studio_Id_vod__c", "Studio_Version_vod__c", "Name"]
};

const APP_TYPES_TO_OBJECT_RECORD_TYPES_MAPPING = {
  Account: "Account",
  Account_Plan: "Account_Plan_vod__c",
  Call: "Call2_vod__c",
  Orders: "Order_vod__c",
  Inventory_Monitoring: "Inventory_Monitoring_vod__c",
  Speaker: "EM_Speaker_vod__c",
  territory_feedback: "Territory_Feedback_vod"
};

const ACTION_LABELS = {
  create: "CREATE",
  remove: "REMOVE",
  update: "UPDATE",
  noAction: "noAction"
};

const STUDIO_DATA_TYPE = {
  STRING: "string",
  NUMBER: "number",
  DATE: "date",
  BOOLEAN: "bool",
  DATE_TIME: "datetime"
};

const FIELD_TYPE_MAPPING = {
  id: STUDIO_DATA_TYPE.STRING,
  double: STUDIO_DATA_TYPE.NUMBER,
  integer: STUDIO_DATA_TYPE.NUMBER,
  int: STUDIO_DATA_TYPE.NUMBER,
  reference: STUDIO_DATA_TYPE.STRING,
  string: STUDIO_DATA_TYPE.STRING,
  picklist: STUDIO_DATA_TYPE.STRING,
  textarea: STUDIO_DATA_TYPE.STRING,
  phone: STUDIO_DATA_TYPE.STRING,
  url: STUDIO_DATA_TYPE.STRING,
  percent: STUDIO_DATA_TYPE.NUMBER,
  email: STUDIO_DATA_TYPE.STRING,
  multipicklist: STUDIO_DATA_TYPE.STRING,
  date: STUDIO_DATA_TYPE.DATE,
  datetime: STUDIO_DATA_TYPE.DATE_TIME,
  checkbox: STUDIO_DATA_TYPE.BOOLEAN,
  boolean: STUDIO_DATA_TYPE.BOOLEAN,
  currency: STUDIO_DATA_TYPE.NUMBER,
  combobox: STUDIO_DATA_TYPE.STRING,
  char: STUDIO_DATA_TYPE.STRING,
  varchar: STUDIO_DATA_TYPE.STRING,
  decimal: STUDIO_DATA_TYPE.NUMBER,
  float: STUDIO_DATA_TYPE.NUMBER,
  real: STUDIO_DATA_TYPE.NUMBER,
  tinyint: STUDIO_DATA_TYPE.NUMBER,
  smallint: STUDIO_DATA_TYPE.NUMBER,
  bigint: STUDIO_DATA_TYPE.NUMBER,
  timestamp: STUDIO_DATA_TYPE.DATE_TIME
};

const UNSUPPORTED_FIELD_TYPE = new Set(["anyType", "time"]);

const GROUP_CLAUSE_TYPE = {
  AND: {
    value: "and",
    text: "And"
  },
  OR: {
    value: "or",
    text: "Or"
  }
};

const HTML_REPORT_FIELD_NAMES = {
  Studio_Id_vod__c: "Studio_Id_vod__c",
  Studio_Version_vod__c: "Studio_Version_vod__c",
  Phone_vod__c: "Phone_vod__c",
  Profile_Name_vod__c: "Profile_Name_vod__c",
  Profile_vod__c: "Profile_vod__c",
  Platform_vod__c: "Platform_vod__c",
  Status_vod__c: "Status_vod__c",
  Failure_Msg_vod__c: "Failure_Msg_vod__c",
  Object_RecordType_Id_vod__c: "Object_RecordType_Id_vod__c",
  Object_RecordType_vod__c: "Object_RecordType_vod__c",
  Name: "Name",
  RecordType: "RecordTypeId",
  External_Id_vod__c: "External_Id_vod__c",
  Visibility_Criteria_vod__c: "Visibility_Criteria_vod__c",
  Sharing_Group_vod__c: "Sharing_Group_vod__c"
};

const SALES_DATA_FIELD_NAMES = {
  Sales_Date_vod__c: "Sales_Date_vod__c",
  Sales_Data_vod__c: "Sales_Data_vod__c"
};

const SALES_DATA_API_ERROR_MESSAGES = {
  noAccountToQuery: "No account available to query",
  failedToGetAnalyticsFileObject: "Fail to get AnalyticsFile object"
};

const ONE_ONE_CALCULATION_EXPRESSIONS = [
  "EXP_COUNT_UNIQUE",
  "EXP_DATE_MONTH",
  "EXP_FORMAT_DATE",
  "EXP_DATE_YEAR",
  "EXP_DATE_DAY_IN_MONTH",
  "EXP_PICK_ONE",
  "EXP_FLOOR_DATE",
  "EXP_CEILING_DATE",
  "EXP_ADDITION_DATE",
  "EXP_SUBTRACTION_DATE",
  "EXP_MAX",
  "EXP_MIN",
  "EXP_DIVIDE_NUM",
  "EXP_ALL",
  "EXP_ANY",
  "EXP_MULTIPLY_NUM",
  "EXP_ADD_NUM",
  "EXP_SUBTRACT_NUM",
  "EXP_SUM",
  "EXP_PRODUCT",
  "EXP_ROUND_NUM",
  "EXP_NUMBER_TO_STRING",
  "EXP_CONCAT"
];

const TRANSLATION_TAG = "_Translation";

const DATA_ELEMENT_TYPE = {
  CONTEXT_QUERY: "DATA_EL_CONTEXT_QUERY",
  CRM_QUERY: "DATA_EL_CRM_QUERY",
  ONE_FOR_ONE: "DATA_EL_ONE_FOR_ONE",
  SUMMARIZE: "DATA_EL_SUMMARIZE",
  TODAY: "DATA_EL_TODAY",
  NOW: "DATA_EL_NOW",
  OBJECT_TRANSLATION: "DATA_EL_OBJECT_TRANSLATION",
  FIELD_TRANSLATION: "DATA_EL_FIELD_TRANSLATION",
  VEEVA_MESSAGES: "DATA_EL_VEEVA_MESSAGES",
  SORT_LIST: "DATA_EL_SORT_LIST",
  MERGE_LIST: "DATA_EL_MERGE_LIST",
  FILTER_LIST: "DATA_EL_FILTER_LIST",
  SUBLIST: "DATA_EL_SUBLIST",
  NITRO_QUERY: "DATA_EL_NITRO_QUERY",
  SALES_DATA_QUERY: "DATA_EL_SALES_DATA_QUERY",
  DROPDOWN: "Dropdown State",
  DATEPICKER: "Date Picker State",
  ALIGNED_TERRITORIES: "DATA_EL_ALIGNED_TERRITORIES",
  CRM_DATA_ENGINE: "DATA_EL_CRM_DATA_ENGINE",
  FEEDBACK_OVERVIEW: "DATA_EL_FEEDBACK_OVERVIEW",
  FEEDBACK_CHANNEL_GOALS: "DATA_EL_FEEDBACK_CHANNEL_GOALS",
  FEEDBACK_PRODUCT_GOALS: "DATA_EL_FEEDBACK_PRODUCT_GOALS",
  FEEDBACK_ACCOUNT_DATA: "DATA_EL_FEEDBACK_ACCOUNT_DATA",
  FEEDBACK_ACCOUNT_CHANNEL_GOALS: "DATA_EL_FEEDBACK_ACCOUNT_CHANNEL_GOALS",
  FEEDBACK_ACCOUNT_PRODUCT_GOALS: "DATA_EL_FEEDBACK_ACCOUNT_PRODUCT_GOALS",
  FEEDBACK_ACCOUNT_PRODUCT_METRICS: "DATA_EL_FEEDBACK_ACCOUNT_PRODUCT_METRICS",
  CALL_ATTENDEES: "DATA_EL_CALL_ATTENDEES"
};

const DATA_ELEMENT_TYPE_TO_LABEL = {
  CONTEXT_QUERY: "contextQuery",
  CRM_QUERY: "crmQuery",
  ONE_FOR_ONE: "oneForOne",
  SUMMARIZE: "summarize",
  TODAY: "today",
  NOW: "now",
  OBJECT_TRANSLATION: "objectTranslation",
  FIELD_TRANSLATION: "fieldTranslation",
  VEEVA_MESSAGES: "veevaMessages",
  SORT_LIST: "sortList",
  MERGE_LIST: "mergeList",
  FILTER_LIST: "filterList",
  SUBLIST: "sublist",
  NITRO_QUERY: "nitroQuery",
  SALES_DATA_QUERY: "salesDataQuery",
  ALIGNED_TERRITORIES: "alignedTerritories",
  CRM_DATA_ENGINE: "dataEngineQuery",
  FEEDBACK_OVERVIEW: "overview",
  FEEDBACK_CHANNEL_GOALS: "channelGoals",
  FEEDBACK_PRODUCT_GOALS: "productGoals",
  FEEDBACK_ACCOUNT_DATA: "accountData",
  FEEDBACK_ACCOUNT_CHANNEL_GOALS: "accountChannelGoals",
  FEEDBACK_ACCOUNT_PRODUCT_GOALS: "accountProductGoals",
  FEEDBACK_ACCOUNT_PRODUCT_METRICS: "accountProductMetrics",
  CALL_ATTENDEES: "callAttendees"
};

const GET_DATA_ELEMENT_TYPES = [
  "DATA_EL_CONTEXT_QUERY",
  "DATA_EL_CRM_QUERY",
  "DATA_EL_NITRO_QUERY",
  "DATA_EL_SALES_DATA_QUERY",
  "DATA_EL_TODAY",
  "DATA_EL_NOW",
  "DATA_EL_VEEVA_MESSAGES",
  "DATA_EL_OBJECT_TRANSLATION",
  "DATA_EL_FIELD_TRANSLATION",
  "DATA_EL_ALIGNED_TERRITORIES",
  DATA_ELEMENT_TYPE.CRM_DATA_ENGINE,
  DATA_ELEMENT_TYPE.CALL_ATTENDEES
];

const CALCULATE_DATA_ELEMENT_TYPES = [
  "DATA_EL_SORT_LIST",
  "DATA_EL_MERGE_LIST",
  "DATA_EL_FILTER_LIST",
  "DATA_EL_ONE_FOR_ONE",
  "DATA_EL_SUBLIST",
  "DATA_EL_SUMMARIZE"
];

const TERRITORY_FEEDBACK_DATA_ELEMENT_TYPES = [
  DATA_ELEMENT_TYPE.FEEDBACK_OVERVIEW,
  DATA_ELEMENT_TYPE.FEEDBACK_CHANNEL_GOALS,
  DATA_ELEMENT_TYPE.FEEDBACK_PRODUCT_GOALS,
  DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_DATA,
  DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_CHANNEL_GOALS,
  DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_PRODUCT_GOALS,
  DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_PRODUCT_METRICS
];

const FIELD_TYPE = {
  REFERENCE: "reference",
  ID: "id",
  PICKLIST: "picklist",
  MULTI_SELECT_PICKLIST: "multipicklist"
};

const EDIT_MODAL_TYPES = {
  [DATA_ELEMENT_TYPE.CONTEXT_QUERY]: "context-edit-modal_",
  [DATA_ELEMENT_TYPE.CRM_QUERY]: "crm-edit-modal_",
  [DATA_ELEMENT_TYPE.SALES_DATA_QUERY]: "sales-edit-modal_",
  [DATA_ELEMENT_TYPE.ONE_FOR_ONE]: "one-one-edit-modal_",
  [DATA_ELEMENT_TYPE.SUMMARIZE]: "summarize-edit-modal_",
  [DATA_ELEMENT_TYPE.OBJECT_TRANSLATION]: "object-translation-edit-modal_",
  [DATA_ELEMENT_TYPE.FIELD_TRANSLATION]: "field-translation-edit-modal_",
  [DATA_ELEMENT_TYPE.VEEVA_MESSAGES]: "vmsg-edit-modal_",
  [DATA_ELEMENT_TYPE.SORT_LIST]: "sort-list-edit-modal_",
  [DATA_ELEMENT_TYPE.MERGE_LIST]: "merge-list-edit-modal_",
  [DATA_ELEMENT_TYPE.FILTER_LIST]: "filter-list-edit-modal_",
  [DATA_ELEMENT_TYPE.SUBLIST]: "sublist-edit-modal_",
  [DATA_ELEMENT_TYPE.NITRO_QUERY]: "nitro-edit-modal_",
  [DATA_ELEMENT_TYPE.TODAY]: "today-edit-modal_",
  [DATA_ELEMENT_TYPE.NOW]: "now-edit-modal_",
  [DATA_ELEMENT_TYPE.DROPDOWN]: "dropdown-edit-modal_",
  [DATA_ELEMENT_TYPE.DATEPICKER]: "datepicker-edit-modal_",
  [DATA_ELEMENT_TYPE.ALIGNED_TERRITORIES]: "aligned-territories-edit-modal_",
  [DATA_ELEMENT_TYPE.CRM_DATA_ENGINE]: "data-engine-edit-modal_",
  [DATA_ELEMENT_TYPE.FEEDBACK_OVERVIEW]: "feedback-overview-edit-modal_",
  [DATA_ELEMENT_TYPE.FEEDBACK_CHANNEL_GOALS]: "feedback-channel-goals-edit-modal_",
  [DATA_ELEMENT_TYPE.FEEDBACK_PRODUCT_GOALS]: "feedback-product-goals-edit-modal_",
  [DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_DATA]: "feedback-account-data-edit-modal_",
  [DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_CHANNEL_GOALS]: "feedback-account-channel-goals-edit-modal_",
  [DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_PRODUCT_GOALS]: "feedback-account-product-goals-edit-modal_",
  [DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_PRODUCT_METRICS]: "feedback-account-product-metrics-edit-modal_",
  [DATA_ELEMENT_TYPE.CALL_ATTENDEES]: "call-attendees-edit-modal_"
};

const RICH_RESULT_CONTENT_TYPE = [
  "Account_Plan_vod",
  "Account_Plan_vod__c", //include the __c version for search from Settings.vue/Properties tab
  "Inventory_Monitoring_vod",
  "Inventory_Monitoring_vod__c",
  "Orders_vod",
  "Orders_vod__c",
  "Call2_vod",
  "Call2_vod__c"
];

const STYLE = {
  UI_ACTION: {
    DRAG_START: "drag_start",
    DROPZONE_HOVER: "dropzone_hover",
    DROP_OVER: "drop-over",
    SHRINK: "m-shrink",
    HIGHTLIGHT_TEXT: "highlight-text"
  }
};

const TOAST_OPTIONS = {
  bottomCenter: {
    solid: true,
    toaster: "b-toaster-bottom-center",
    variant: "danger"
  }
};

const HELPER_DOCS = {
  phoneLink:
    "https://crmhelp.veeva.com/doc/Content/CRM_topics/MyInsights/MyInsightsAdvFunct/ViewiPhone.htm",
  platformLink:
    "https://crmhelp.veeva.com/doc/Content/CRM_topics/MyInsights/MyInsightsInitConfig/MyInsightsConfig.htm",
  createContentLink:
    "https://crmhelp.veeva.com/doc/Content/CRM_topics/MyInsightsStudio/CreatePage.htm",
  deployContentTypeLink:
    "https://crmhelp.veeva.com/doc/Content/CRM_topics/MyInsightsStudio/DeployPage.htm"
};

const ROUTE_NAMES = {
  appsList: "AppsList",
  templatesList: "TemplatesList",
  distributionChannels: "DistributionChannels",
  distributionChannelDetails: "DistributionChannelDetails",
  distributionChannelOverview: "DistributionChannelOverview",
  distributionChannelCustomDisplayElements:
    "DistributionChannelCustomDisplayElements",
  distributionChannelCustomerDomains: "DistributionChannelCustomerDomains",
  customDisplayElementDetails: "CustomDisplayElementDetails",
  customDisplayElementVersionDetails: "CustomDisplayElementVersionDetails"
};

const PAGES_PATH = {
  APPS: "apps",
  DISTRIBUTION_CHANNELS: "distribution-channels"
};

const INPUT_ELEMENT = {
  TRANSLATION_LABEL_MAX_CHARS: 140,
  ACCEPT_ZIP: "application/zip, application/x-zip-compressed, multipart/x-zip"
};

const STATUS_CODE = {
  FORBIDDEN: 403,
  BAD_REQUEST: 400
};

const TOAST_CONFIG = {
  BOTTOM_CENTER_ERROR: {
    solid: true,
    toaster: "b-toaster-bottom-center",
    variant: "danger"
  },
  BOTTOM_CENTER_SUCCESS: {
    solid: true,
    toaster: "b-toaster-bottom-center",
    variant: "success"
  }
};

const SOSL_LIMIT = 50;

const CREATE_WIZARD_SOSL_SEARCH_MAP = {
  Account: {
    searchQuery: "{userInput*}",
    searchGroup: "Name Fields",
    objectsAndFields: "Account(Id, Name, Formatted_Name_vod__c)",
    limit: SOSL_LIMIT
  },

  Account_Plan: {
    additionalQuery: true,
    searchQuery: "{userInput*}",
    searchGroup: "Name Fields",
    objectsAndFields:
      "Account(Id, Name, Formatted_Name_vod__c), Account_Plan_vod__c(Id, Name, Account_vod__r.Formatted_Name_vod__c)",
    object: "Account_Plan_vod__c",
    fields: ["Id", "Name", "Account_vod__r.Formatted_Name_vod__c"],
    where: "(Account_vod__r.Id IN (ids))"
  },
  Orders: {
    additionalQuery: true,
    searchQuery: "{userInput*}",
    searchGroup: "Name Fields",
    objectsAndFields:
      "Account(Id, Name, Formatted_Name_vod__c), Order_vod__c(Id, Name, Account_vod__r.Formatted_Name_vod__c)",
    object: "Order_vod__c",
    fields: ["Id", "Name", "Account_vod__r.Formatted_Name_vod__c"],
    where: "(Account_vod__r.Id IN (ids))"
  },
  Inventory_Monitoring: {
    additionalQuery: true,
    searchQuery: "{userInput*}",
    searchGroup: "Name Fields",
    objectsAndFields:
      "Account(Id, Name, Formatted_Name_vod__c), Inventory_Monitoring_vod__c(Id, Name, Account_vod__r.Formatted_Name_vod__c)",
    object: "Inventory_Monitoring_vod__c",
    fields: ["Id", "Name", "Account_vod__r.Formatted_Name_vod__c"],
    where: "(Account_vod__r.Id IN (ids))"
  },
  Speaker: {
    additionalQuery: true,
    searchQuery: "{userInput*}",
    searchGroup: "Name Fields",
    objectsAndFields:
      "Account(Id, Name, Formatted_Name_vod__c), EM_Speaker_vod__c(Id, Name, Account_vod__r.Formatted_Name_vod__c)",
    object: "EM_Speaker_vod__c",
    fields: ["Id", "Name", "Account_vod__r.Formatted_Name_vod__c"],
    where: "(Account_vod__r.Id IN (ids))"
  },
  Call: {
    additionalQuery: true,
    searchQuery: "{userInput*}",
    searchGroup: "Name Fields",
    objectsAndFields:
      "Account(Id, Name, Formatted_Name_vod__c), Call2_vod__c(Id, Name, Account_vod__r.Formatted_Name_vod__c)",
    object: "Call2_vod__c",
    fields: ["Id", "Name", "Account_vod__r.Formatted_Name_vod__c"],
    where: "(Account_vod__r.Id IN (ids))"
  }
};

const ELM_BLACK_BOX_ERRORS = {
  CANNOT_FIND_MANIFEST: "CannotFindManifest"
};

const DISPLAY_ELEMENT_MESSAGE_KEY = {
  METRIC_HIGHLIGHT: "metricHighlight",
  DROPDOWN: "dropdown",
  DATE_PICKER: "datepicker"
};

const DATE_INTERVALS = {
  MILLISECONDS: "MILLISECONDS",
  SECOND: "SECOND",
  MINUTE: "MINUTE",
  HOUR: "HOUR",
  DAY: "DAY",
  WEEK: "WEEK",
  MONTH: "MONTH",
  QUARTER: "QUARTER",
  YEAR: "YEAR",
  DECADE: "DECADE",
  CENTURY: "CENTURY",
  MILLENNIUM: "MILLENNIUM"
};

const CRM_DATA_ENGINE_OPERAND_TYPE = {
  QUOTE: "QUOTE",
  CONCAT: "CONCAT",
  DATE_TRUNC: "DATE_TRUNC",
  DIV: "DIV",
  MULTI: "MULTI",
  MINUS: "MINUS",
  PLUS: "PLUS",
  SUM: "SUM",
  COUNT: "COUNT",
  COUNT_DISTINCT: "COUNT_DISTINCT",
  MAX: "MAX",
  MIN: "MIN"
};

const CRM_DATA_ENGINE_SINGLE_INPUT = [
  CRM_DATA_ENGINE_OPERAND_TYPE.QUOTE,
  CRM_DATA_ENGINE_OPERAND_TYPE.CONCAT,
  CRM_DATA_ENGINE_OPERAND_TYPE.DATE_TRUNC,
  CRM_DATA_ENGINE_OPERAND_TYPE.SUM,
  CRM_DATA_ENGINE_OPERAND_TYPE.COUNT,
  CRM_DATA_ENGINE_OPERAND_TYPE.COUNT_DISTINCT,
  CRM_DATA_ENGINE_OPERAND_TYPE.MAX,
  CRM_DATA_ENGINE_OPERAND_TYPE.MIN
];

const CRM_DATA_ENGINE_NUMBER_OPERAND = [
  CRM_DATA_ENGINE_OPERAND_TYPE.DIV,
  CRM_DATA_ENGINE_OPERAND_TYPE.MULTI,
  CRM_DATA_ENGINE_OPERAND_TYPE.MINUS,
  CRM_DATA_ENGINE_OPERAND_TYPE.PLUS
];

const CRM_DATA_ENGINE_DIMENSIONS = [
  {
    type: "QUOTE",
    as: "",
    text: ""
  },
  {
    type: "CONCAT",
    as: "",
    arguments: []
  },
  {
    type: "DATE_TRUNC",
    as: "",
    interval: "",
    field: ""
  },
  {
    type: "DIV",
    fieldA: "",
    fieldB: "",
    as: ""
  },
  {
    type: "MULTI",
    fieldA: "",
    fieldB: "",
    as: ""
  },
  {
    type: "MINUS",
    fieldA: "",
    fieldB: "",
    as: ""
  },
  {
    type: "PLUS",
    fieldA: "",
    fieldB: "",
    as: ""
  }
];

const CRM_DATA_ENGINE_METRICS_OPERAND = [
  CRM_DATA_ENGINE_OPERAND_TYPE.SUM,
  CRM_DATA_ENGINE_OPERAND_TYPE.COUNT,
  CRM_DATA_ENGINE_OPERAND_TYPE.COUNT_DISTINCT,
  CRM_DATA_ENGINE_OPERAND_TYPE.MAX,
  CRM_DATA_ENGINE_OPERAND_TYPE.MIN
];

const CRM_DATA_ENGINE_METRICS = [
  {
    type: "SUM",
    field: "",
    as: ""
  },
  {
    type: "COUNT",
    field: "",
    as: ""
  },
  {
    type: "COUNT_DISTINCT",
    field: "",
    as: ""
  },
  {
    type: "MAX",
    field: "",
    as: ""
  },
  {
    type: "MIN",
    field: "",
    as: ""
  }
];

const CONTENT_TYPES = {
  ACCOUNT: "Account",
  CALL: "Call",
  TERRITORY: "Territory"
};

const NAVIGATION_ACTIONS = {
  VIEW_SECTION: "VIEW_SECTION",
  VIEW_RECORD: "VIEW_RECORD",
  EDIT_RECORD: "EDIT_RECORD"
};

const PLATFORMS = {
  APP: "APP",
  BROWSER: "BROWSER"
};

export {
  MUTATION_NAME,
  CREATE_WIZARD_SEARCH_MAP,
  VEEVA_MESSAGE_NAME_QUERY_TEMPLATE,
  VEEVA_MESSAGE_CATEGORY_QUERY_TEMPLATE,
  STUDIO_MESSAGES,
  VEEVA_MESSAGES,
  EXP_MESSAGES,
  OBJECT_NAME_LABELS,
  DEPLOYMENTS_COLUMN_KEYS,
  ENTRY_POINT_OBJECTS_MAPPING,
  REQUIRED_FLS_TO_DEPLOY,
  APP_TYPES_TO_OBJECT_RECORD_TYPES_MAPPING,
  ACTION_LABELS,
  STUDIO_DATA_TYPE,
  FIELD_TYPE_MAPPING,
  UNSUPPORTED_FIELD_TYPE,
  HTML_REPORT_FIELD_NAMES,
  SALES_DATA_FIELD_NAMES,
  SALES_DATA_API_ERROR_MESSAGES,
  GROUP_CLAUSE_TYPE,
  EDIT_MODAL_TYPES,
  DATA_ELEMENT_TYPE,
  DATA_ELEMENT_TYPE_TO_LABEL,
  GET_DATA_ELEMENT_TYPES,
  CALCULATE_DATA_ELEMENT_TYPES,
  TERRITORY_FEEDBACK_DATA_ELEMENT_TYPES,
  ONE_ONE_CALCULATION_EXPRESSIONS,
  STYLE,
  TOAST_OPTIONS,
  RICH_RESULT_CONTENT_TYPE,
  HELPER_DOCS,
  ROUTE_NAMES,
  STATUS_CODE,
  TOAST_CONFIG,
  CREATE_WIZARD_SOSL_SEARCH_MAP,
  SOSL_LIMIT,
  PAGES_PATH,
  INPUT_ELEMENT,
  ELM_BLACK_BOX_ERRORS,
  FIELD_TYPE,
  CRM_DATA_ENGINE_OPERAND_TYPE,
  DISPLAY_ELEMENT_MESSAGE_KEY,
  DATE_INTERVALS,
  CRM_DATA_ENGINE_DIMENSIONS,
  CRM_DATA_ENGINE_METRICS,
  CRM_DATA_ENGINE_SINGLE_INPUT,
  CRM_DATA_ENGINE_NUMBER_OPERAND,
  CRM_DATA_ENGINE_METRICS_OPERAND,
  TRANSLATION_TAG,
  VISIBILITY_CRITERIA_TYPES,
  CONTENT_TYPES,
  NAVIGATION_ACTIONS,
  PLATFORMS
};
